import {
  classNames,
  FlexColumn,
  SpaceBetween,
  TextBody,
  TextLabel,
} from "@opensea/ui-kit"
import {
  StudioPageHeader,
  type StudioPageHeaderProps,
} from "./StudioPageHeader"

export type StudioFieldProps = {
  description?: string | React.ReactNode

  error?: string
  characterCount?: number
  maxCharacterCount?: number

  children: React.ReactNode
  className?: string
} & Pick<
  StudioPageHeaderProps,
  "title" | "tooltip" | "optional" | "tooltipClassName"
>

export function StudioField({
  description,
  characterCount,
  maxCharacterCount,
  children,
  className,
  ...rest
}: StudioFieldProps) {
  return (
    <FlexColumn className={classNames("gap-2", className)}>
      <StudioPageHeader {...rest} size="xs" />
      {children}
      {description || characterCount || maxCharacterCount ? (
        <SpaceBetween>
          {description ? (
            <TextBody color="text-secondary" size="xs">
              {description}
            </TextBody>
          ) : (
            <span />
          )}
          {characterCount || maxCharacterCount ? (
            <TextLabel color="text-secondary" size="xs">
              {(characterCount || 0).toLocaleString()}/
              {maxCharacterCount?.toLocaleString()}
            </TextLabel>
          ) : (
            <span />
          )}
        </SpaceBetween>
      ) : null}
    </FlexColumn>
  )
}
